<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      border?: boolean;
    }>(),
    {
      border: true,
    },
  );
</script>

<template>
  <div
    data-slot="card"
    :class="
      cn(
        'bg-card text-card-foreground flex flex-col gap-6 rounded-sm py-6',
        border && 'border',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
